module.exports = __webpack_public_path__ + "img/talviuimapaikka_original.ee055f73.jpg";